
    // this file was auto generated by python script
    import CheckSquare from './CheckSquare';
    export default CheckSquare;
    